function autoFocus($parse, $timeout) {
	return {
		link: function(scope, element, attrs) {
			const model = $parse(attrs.autoFocus);

			if(!!model()) {
				scope.$watch(model, function(value) {
					if(!!value) {
						$timeout(function() {
							element[0].focus();
						});
					}
				});
			}
		}
	};
}

export default angular
	.module("vesl.behaviors.auto-focus", [])
	.directive("autoFocus", autoFocus).name;
